import React from 'react';

export const SpecialCharDisplay = ({value}) => {
    return <div dangerouslySetInnerHTML={{ __html: value}}></div>;
}